import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Link from '@material-ui/core/Link';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';

// UTILITY
import { checkIsAbsoluteUrl, routeEnhance } from '@/utility/routes';
import { externalLink } from '@/utility/analytics';

// COMPONENTS
import ReactHtml from '@/components/ReactHtml';
import ShowMoreText from '@/components/ShowMoreText';

function externalLinkClicked(href) {
  externalLink({ href });
}

const AppDescription = ({ text, textStyles, applyLinkStyles, showCollapse }) => {
  const [t] = useTranslation();

  const getLinkComponent = ({ href, ...restProps }) => {
    if (!href) return null;

    const isExternalLink = checkIsAbsoluteUrl(href);

    if (isExternalLink) {
      return applyLinkStyles ? (
        <Link
          className={textStyles}
          href={href}
          {...restProps}
          onClick={() => externalLinkClicked(href)}
        />
      ) : (
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        <a href={href} {...restProps} onClick={() => externalLinkClicked(href)} />
      );
    }

    return applyLinkStyles ? (
      <Link className={textStyles} to={routeEnhance(href)} {...restProps} component={HashLink} />
    ) : (
      <HashLink to={routeEnhance(href)} {...restProps} />
    );
  };

  const descrContent = (
    <ReactHtml
      className={clsx('markdown app-descr', textStyles)}
      components={{
        a: getLinkComponent,
      }}
    >
      {text.trim()}
    </ReactHtml>
  );

  return (
    <>
      {showCollapse ? (
        <ShowMoreText
          showLessText={t('buttons.viewLess')}
          showMoreText={t('buttons.viewMore')}
          collapsedHeight={290}
          showExpandIcon={false}
          controlsAlignment="right"
          btnProps={{ className: 'text-color--purple', underline: 'always' }}
        >
          {descrContent}
        </ShowMoreText>
      ) : (
        descrContent
      )}
    </>
  );
};

AppDescription.defaultProps = {
  textStyles: '',
  applyLinkStyles: false,
  showCollapse: false,
};

AppDescription.propTypes = {
  text: PropTypes.string.isRequired,
  textStyles: PropTypes.string, // p1, p3
  applyLinkStyles: PropTypes.bool,
  showCollapse: PropTypes.bool,
};

export default AppDescription;
